module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('header', [_c('router-link', {
    attrs: {
      "to": "./"
    }
  }, [_vm._v("‹ quit")]), _vm._v(" "), _c('span', [_vm._v("Round " + _vm._s(_vm.round))]), _c('span')]), _vm._v(" "), _c('main', _vm._l((_vm.players), function(player, index) {
    return _c('player', {
      attrs: {
        "player": player,
        "index": index,
        "players": _vm.players
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a9014a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Overview.vue
// module id = 91
// module chunks = 2